/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PresignUploadResponse
 */
export interface PresignUploadResponse {
    /**
     * 
     */
    objectKey?: string;
    /**
     * 
     */
    uploadUrl?: string;
}

/**
 * Check if a given object implements the PresignUploadResponse interface.
 */
export function instanceOfPresignUploadResponse(value: object): value is PresignUploadResponse {
    return true;
}

export function PresignUploadResponseFromJSON(json: any): PresignUploadResponse {
    return PresignUploadResponseFromJSONTyped(json, false);
}

export function PresignUploadResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PresignUploadResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'objectKey': json['objectKey'] == null ? undefined : json['objectKey'],
        'uploadUrl': json['uploadUrl'] == null ? undefined : json['uploadUrl'],
    };
}

export function PresignUploadResponseToJSON(json: any): PresignUploadResponse {
    return PresignUploadResponseToJSONTyped(json, false);
}

export function PresignUploadResponseToJSONTyped(value?: PresignUploadResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'objectKey': value['objectKey'],
        'uploadUrl': value['uploadUrl'],
    };
}

